export default function () {
  return [
    { key: 'id', label: 'id' },
    { key: 'name', label: 'name' },
    // Department type — a real select (was a free-text input nobody could guess)
    {
      key: 'type',
      label: 'Type of business unit',
      type: 'select',
      props: {
        options: ['SALES', 'RETENTION', 'LANDING'],
        clearable: true,
        multiple: false,
      },
    },
    // Organization — narrows server-side (field used to be dropped from the request)
    { key: 'orgId', type: 'org', props: { clearable: true, multiple: false } },
    { key: 'phone', label: 'phone' },
    { key: 'address', label: 'address' },
    { key: 'contact', label: 'contact' },
    { key: 'website', label: 'website' },
    { key: 'email', label: 'email' },
  ]
}
